/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'connection-add': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M37 33.6h-3v3h-2.6v-3h-3V31h3v-3H34v3h3v2.6zm-9.1-16.5v2.5c0 1.2-.9 2.1-2 2.2v5.4c0 .4-.1.8-.4 1L23 30.9h3.2v3h-8.3c-.1 1.1-1.1 2-2.2 2h-2.5c-1.2 0-2.2-1-2.2-2.2v-2.5c0-1.2 1-2.2 2.2-2.2h2.5c1.2 0 2.1.9 2.2 2h1l4.1-4.3v-4.8c-1.1-.1-2-1.1-2-2.2v-2.5c0-1.2 1-2.2 2.2-2.2h2.5c1.2-.1 2.2.9 2.2 2.1zm-12 14c0-.1-.1-.2-.2-.2h-2.5c-.1 0-.2.1-.2.2v2.5c0 .1.1.2.2.2h2.5c.1 0 .2-.1.2-.2v-2.5zm10-14c0-.1-.1-.2-.2-.2h-2.5c-.1 0-.2.1-.2.2v2.5c0 .1.1.2.2.2h2.5c.1 0 .2-.1.2-.2v-2.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/connection-add.js